import * as React from "react"

import { cn } from "../../lib/utils"

const Input = React.forwardRef<HTMLInputElement, React.ComponentProps<"input">>(
  ({ className, type, ...props }, ref) => {
    return (
      <input
        type={type}
        // Token-first: the input surface follows the active theme via the
        // shadcn tokens (`--input-bg` fill / `text-foreground`), so it's a warm
        // filled field in a light app and brand-dark inside a dark shell or dark
        // modal — never a hardcoded white field stranded on a dark surface. The
        // fill falls back to `--background` wherever `--input-bg` isn't defined
        // (i.e. dark modes), preserving prior behavior there. Border / ring /
        // placeholder are tokenised too so contrast is correct by construction.
        className={cn(
          "flex h-9 w-full rounded-md border border-[hsl(var(--border-input,var(--input)))] bg-[hsl(var(--input-bg,var(--background)))] text-foreground px-3 py-1 text-base transition-colors file:border-0 file:bg-transparent file:text-sm file:font-medium file:text-foreground placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:cursor-not-allowed disabled:opacity-50 md:text-sm",
          className
        )}
        ref={ref}
        {...props}
      />
    )
  }
)
Input.displayName = "Input"

export { Input }
